const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const loginSlice = createSlice({
  name: "login",
  initialState: {
    isLogin: false,
    token: null,
  },
  reducers: {
    setIsLogin(state, action) {
      state.isLogin = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
  },
});

export const loginActions = loginSlice.actions;
export default loginSlice;
